<div class="bg-[#FAFAFA] rounded-[20px] p-4 sm:p-6 space-y-6">

    <!-- PAGE HEADER -->
    <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-4">
            <button (click)="router.navigate(['/guarantor-setup'])"
                class="group flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-slate-500 bg-white border border-slate-200 rounded-lg hover:border-indigo-200 hover:text-indigo-600 hover:bg-indigo-50 transition-all shadow-sm">
                <fa-icon [icon]="faArrowLeft"
                    class="inline-block text-xs group-hover:-translate-x-0.5 rtl:group-hover:translate-x-0.5 rtl:-scale-x-100 transition-transform"></fa-icon>
                <span>{{ 'COMMON.BACK' | translate }}</span>
            </button>
            <div class="h-6 w-px bg-slate-200 mx-1"></div>
            <h1 class="text-xl sm:text-xl font-semibold text-[#444A6D]">
                {{ 'SETUP.GUARANTOR_CLIENT_LIST.TITLE' | translate }}
            </h1>
        </div>
        <button
            class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg shadow-sm hover:bg-indigo-700 transition-colors"
            (click)="openGuarantorClient()">
            {{ 'SETUP.GUARANTOR_CLIENT_LIST.ADD_BUTTON' | translate }}
        </button>
    </div>

    <!-- =========================
                                TABLE
                    =========================== -->
    <div class=" ">
        <div class="">
            <app-table [columns]="columns" [data]="values" [actions]="actions" [enablePagination]="true" [pageSize]="10">
            </app-table>
        </div>
    </div>
</div>
<!-- Popup Modal -->
<app-popup [title]="popupTitle" [fields]="popupFields" [onSave]="SaveGuarantorClient.bind(this)" [show]="showPopup"
    [type]="isDeleteConfirm ? 'confirm' : 'form'" [message]="deleteMessage" [readonly]="isViewMode"
    (showChange)="showPopup = $event" (confirmed)="onDeleteConfirmed()">
</app-popup>
